import { Building2, TrendingUp, Satellite, Globe2, Handshake, PiggyBank } from 'lucide-react';
import type { Skill } from '../types/content';

export const skills: Skill[] = [
  {
    icon: Building2,
    title: 'Enterprise & P&L Leadership',
    description: 'Full accountability for enterprise performance and financial outcomes.'
  },
  {
    icon: TrendingUp,
    title: 'Corporate & Commercial Strategy',
    description: 'Shaping strategic direction across complex, multi-market organizations.'
  },
  {
    icon: Satellite,
    title: 'Digital Media Transformation',
    description: 'Leading OTT, FAST, streaming, and IP migration initiatives at scale.'
  },
  {
    icon: Globe2,
    title: 'International Business Development',
    description: 'Scaling commercial reach and global content distribution across markets.'
  },
  {
    icon: Handshake,
    title: 'Strategic Partnerships & Negotiations',
    description: 'Structuring high-stakes alliances that create lasting commercial value.'
  },
  {
    icon: PiggyBank,
    title: 'Financial Stewardship',
    description: 'Disciplined allocation of capital and resources across the enterprise.'
  }
];
